import React from "react";
import ReactDom from "react-dom";
import App from "./App";

import { BrowserRouter, Route, Switch, useHistory } from "react-router-dom";

const routes = (
  <BrowserRouter>
    <Route path="/" component={App} />
  </BrowserRouter>
);

ReactDom.render(routes, document.getElementById("root"));
